module.exports = __webpack_public_path__ + "media/images/pages/fcr-case/case-2-fc7333e058e511156c20efa1580c24ae.png";